module.exports = __webpack_public_path__ + "static/bg-desk-dc5325cb13444a090e66dab2ef35341a.jpg";